import { render, staticRenderFns } from "./PostEditorImages.vue?vue&type=template&id=efe738ee&scoped=true&"
import script from "./PostEditorImages.vue?vue&type=script&lang=js&"
export * from "./PostEditorImages.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorImages.vue?vue&type=style&index=0&id=efe738ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe738ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
